<template>
  <v-form @submit.prevent v-if="selectedPlacement">
    <!-- Theme settings -->
    <v-card class="mb-4 mt-4">
      <v-card-title>Theme</v-card-title>
      <v-card-text>
        <v-select
          v-model="selectedPlacement.theme"
          :items="[
            { title: 'Light', value: 'light' },
            { title: 'Dark', value: 'dark' },
          ]"
          item-title="title"
          item-value="value"
          label="Theme"
        ></v-select>
      </v-card-text>
    </v-card>
    <!-- Image Settings -->
    <v-card class="mb-4">
      <v-card-title>Image</v-card-title>
      <v-card-text>
        <!-- Image Type -->
        <v-select
          v-model="selectedPlacement.imageType"
          :items="[
            { title: 'Front 3/4', value: 'front34' },
            { title: 'Side', value: 'profile' },
          ]"
          item-title="title"
          item-value="value"
          label="Image Type"
        ></v-select>

        <!-- Width -->
        <v-text-field
          v-model="selectedPlacement.image.width"
          label="Width"
        ></v-text-field>

        <!-- Height -->
        <v-text-field
          v-model="selectedPlacement.image.height"
          label="Height"
        ></v-text-field>
      </v-card-text>
    </v-card>

    <!-- Label Settings -->
    <v-card class="mb-4">
      <v-card-title>Label</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-card-text>Color</v-card-text>
            <v-color-picker
              v-model="selectedPlacement.label.color"
              label="Color"
              mode="hex"
              hide-mode-switch
              class="mb-2"
            ></v-color-picker>
          </v-col>
          <v-col cols="12" md="6">
            <v-card-text>Hover Color</v-card-text>
            <v-color-picker
              v-model="selectedPlacement.label.hoverColor"
              label="Hover Color"
              mode="hex"
              hide-mode-switch
              class="mb-2"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card-subtitle>Typography</v-card-subtitle>
            <v-select
              v-model="selectedPlacement.label.typography.fontSize"
              label="Font Size"
              :items="['12px', '14px', '16px', '18px', '20px']"
            ></v-select>
            <v-select
              v-model="selectedPlacement.label.typography.fontWeight"
              label="Font Weight"
              :items="['normal', 'bold', 'light', 'medium']"
            ></v-select>
            <v-select
              v-model="selectedPlacement.label.typography.lineHeight"
              label="Line Height"
              :items="['1em', '1.5em', '2em']"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>

</template>

<script setup lang="ts">
import type { ISettings } from '@/types'
import { ref, onMounted } from 'vue'
import { useSettingsStore } from '@/stores/settings'

const props = defineProps<{
  selectedPlacementId: string
}>()

const settings = useSettingsStore()

const selectedPlacement = ref<ISettings | null>(null)
const originalPlacement = ref<ISettings | null>(null)

onMounted(() => {
  selectedPlacement.value =
    settings.placements.placements[props.selectedPlacementId] ?? []
  originalPlacement.value = JSON.parse(JSON.stringify(selectedPlacement.value))
})
</script>
